import { connect } from 'react-redux';

// Actions:
import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';

import { getActualizationShowModalCustomer } from 'src/routes/Checkout/store/selectors/actualization';
import { getIsWhitelabel } from '../../../store/selectors/view';
import { AgreeBlockContainer } from './AgreeBlockContainer';

const mapStateToProps = (state) => ({
  isWhitelabel: getIsWhitelabel(state),
  isHotelOnly: getIsHotelOnly(state),
  isMobile: getIsMobile(state),
  isIncludedAgreementProvisionAdditionalServices:
    getActualizationShowModalCustomer(state),
});

export default connect(mapStateToProps)(AgreeBlockContainer);
